// Copyright (c) 2022 GrayBits LLC

export default class{
  constructor(element, options = {}){
    this.element = element;
    this.slide_class = options.slide_class || 'slide'
    this.selector_wrapper_class = options.selector_wrapper_class || 'slide_selector_wrapper'
    this.selector_class = options.selector_class || 'slide_selector'
    this.slideSet = options.slide_set;
    this.preSlideSet = options.pre_slide_set;
    element.gm = this;

    if (this.slides.length == 0){
      this.empty = true;
      return;
    }

    this.cycle = element.dataset.cycle;
    this._n = this.slides.length;
    this._previous_index = 0;
    
    if (this.slide_selectors.length > 0 && this.n > 1){
      [].forEach.call(this.slides,
        (slide, i) => {
        [].forEach.call(this.slide_selectors,
          (container) => {
          container.appendChild(this.createSelectorButton(slide, i));
        });
      });
    }
    this.current = 0;
    element.offsetHeight;
  }

  static init(element, options = {}) {
    [].forEach.call((element ? element : document).querySelectorAll(
      options.slideshow_class ? '.' + options.slideshow_class : '.slideshow'), 
      (slideshow) => {  
        if (!slideshow.gm){
          new this(slideshow, options); 
        }
      }
    );
  }

  get slides(){
    return this.element.getElementsByClassName(this.slide_class);
  }

  get slide_selectors(){
    return this.element.getElementsByClassName(this.selector_wrapper_class);
  }

  createSelectorButton(slide, i){
    var slide_button = document.createElement('button');
    slide_button.classList.add(this.selector_class);
    
    if (slide.dataset.selectorLabel){
      slide_button.innerHTML = slide.dataset.selectorLabel;
    } else {
      if (this.element.dataset.indexLabel){
        slide_button.innerHTML = i + 1;
      }
    }
    slide_button.addEventListener('click', () => { this.current = i });
    
    return slide_button;
  }
  
  get current(){
    return this._current;
  }

  get n(){
    return this._n;
  }

  get previous_index(){
    return this._previous_index;
  }

  set current(i){
    i = i * 1;
    if (i == this.current){
      return;
    }
    if (this.preSlideSet){
      this.preSlideSet();
    };
    if (this.current_slide) this.current_slide.classList.remove('current');
    
    if (this.slide_selectors.length > 0 && this.n > 1){
      [].forEach.call(this.slide_selectors,
        (container) => {
          if (this.current != undefined){
            container.children[this.current].classList.remove('current');
          }
          container.children[i].classList.add('current');
      });
    }
    this._previous_index = this.current;
    this._current = i;
    this.slides[i].classList.add('current');

    if (this.slideSet){
      this.slideSet();
    };
    this.element.dispatchEvent(new CustomEvent('gm:slideset',{detail: {current: i, previous: this._previous_index}}));
  }
  
  get current_slide(){
    return this.slides[this.current];
  }

  nextSlide(force){
    var new_slide;
    if (this.cycle){
      new_slide = (this.current + 1) % this.n;
    } else {
      new_slide = Math.min(this.current + 1, this.n - 1);
    }
    this.current = new_slide;
  }

  previousSlide(force){
    var new_slide;
    if (this.cycle){
      new_slide = (this.current + this.n - 1) % this.n;
    } else {
      new_slide = Math.max(this.current - 1, 0);
    }
    this.current = new_slide;
  }
}
